import * as React from 'react';

import { Label, InputWrapper, IconLink } from '../LinkPanel/styles';
import ButtonRemove from '../ButtonRemove';
import Utils from '../../../../utils';
import { getYoutubeLink } from '../../../../containers/Editor/utils/helpers';

interface YoutubeLinkPanelProps {
	value?: string;
	onChange: (value: string) => void;
}

const YoutubeLinkPanel = ({ value, onChange }: YoutubeLinkPanelProps) => {
	const [inputValue, setInputValue] = React.useState(value);
	const handleInputChange = ({ target: { value } }) => {
		if (getYoutubeLink(value)) {
			setInputValue(value);
			onChange(value);
		}
	};

	const handleRemove = () => {
		setInputValue('');
	};

	React.useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<>
			<Label value="messages.copy_paste_your_link" />
			<InputWrapper
				hasLabel={true}
				hasButtonAdd={false}
				hasButtonRemove={!!inputValue}
			>
				<IconLink isYoutubeIcon={true}>
					{Utils.getSvgIcon('iconset_youtube_logo')}
				</IconLink>
				<input
					type="text"
					value={inputValue}
					readOnly={!!inputValue}
					placeholder="https://www.youtube.com/watch"
					onChange={handleInputChange}
				/>
				{!!inputValue &&
					<ButtonRemove onClick={handleRemove} />
				}
			</InputWrapper>
		</>
	);
};

export default YoutubeLinkPanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/EditPanel/YoutubeLinkPanel/index.tsx